import React from 'react';
import { Dayjs } from 'dayjs';
import { Text } from 'components/Typography';
import { Duration, formatDateForUILongFormat, formatTimeRange, ITipCalculatorLaborDataTotals } from 'utils';
import Sidebar from './components/Sidebar';
import { Content, ContentSection, RowItem } from './components/styles';

interface ITipCalcLaborDataSidebarProps {
  dataCy?: string;
  businessDate: Dayjs;
  totals: ITipCalculatorLaborDataTotals;
  continueDisabled?: boolean;
  onBack: () => void;
  onContinue?: () => void;
}

const TipCalcLaborDataSidebar = ({ businessDate, totals, onContinue, onBack, continueDisabled = false, dataCy = 'tip-calc-labor-data-sidebar' }: ITipCalcLaborDataSidebarProps) => {
  const totalFormattedHours = new Duration(totals.totalTippedMinutes).toString();

  return (
    <Sidebar
      title="Labor Data Summary"
      leftActionButton={{ label: 'Back', appearance: 'white', onClick: onBack }}
      rightActionButton={onContinue ? { label: 'Recalculate', appearance: 'primary', disabled: continueDisabled, onClick: onContinue } : undefined}
      dataCy={dataCy}
    >
      <Content>
        <RowItem data-cy={`${dataCy}-business-date`} className="business-date">
          <Text size="small" data-cy={`${dataCy}-business-date-label`}>
            Business Date:
          </Text>
          <Text size="small" data-cy={`${dataCy}-business-date-value`}>
            {formatDateForUILongFormat(businessDate)}
          </Text>
        </RowItem>
        <RowItem data-cy={`${dataCy}-total`} className="total">
          <Text size="small" fontWeight="medium" data-cy={`${dataCy}-total-label`}>
            Total Tipped Hours
          </Text>
          <Text size="small" fontWeight="medium" data-cy={`${dataCy}-total-value`}>
            {totalFormattedHours}
          </Text>
        </RowItem>
        {totals.segments.map((segment) => (
          <ContentSection key={segment.id} data-cy={`${dataCy}-segment-${segment.id}-section`}>
            <Text size="small" fontWeight="medium" data-cy={`${dataCy}-segment-${segment.id}-label`}>
              {segment.name}
            </Text>
            <RowItem data-cy={`${dataCy}-segment-${segment.id}-segment-hours`}>
              <Text size="small" data-cy={`${dataCy}-segment-${segment.id}-segment-hours-label`}>
                Segment Hours
              </Text>
              <Text size="small" data-cy={`${dataCy}-segment-${segment.id}-segment-hours-value`}>
                {formatTimeRange(segment.start, segment.end)}
              </Text>
            </RowItem>
            <RowItem data-cy={`${dataCy}-segment-${segment.id}-total-tipped-hours`}>
              <Text size="small" data-cy={`${dataCy}-segment-${segment.id}-total-tipped-hours-label`}>
                Total Tipped Hours
              </Text>
              <Text size="small" data-cy={`${dataCy}-segment-${segment.id}-total-tipped-hours-value`}>
                {new Duration(segment.totalJobMinutes).toString()}
              </Text>
            </RowItem>
          </ContentSection>
        ))}
      </Content>
    </Sidebar>
  );
};

export default TipCalcLaborDataSidebar;
